<template>
  <div class="app-color">
    <transition name="fade-rigth" mode="out-in">
      <loadVirtual v-if="$store.getters.schedule == null"></loadVirtual>
      <div v-else class="theme virtual">
        <div class="box"></div>
        <!-- VIRTUAL APP -->
        <div class="pl-2 pr-2 mt-2">
          <!-- <div class="title-2 capital mb-2 medium text-no-wrap">Agenda Virtual</div> -->
          <div class="row mb-1">
            <div class="normal capital medium text-no-wrap">Equipo de trabajo</div>
            <div class="spacer"></div>
            <div
              class="normal capital medium text-no-wrap"
            >{{schedule.employees[selected.serverID].serverName}}</div>
          </div>
        </div>

        <!-- AVATRES -->
        <div class="scroll-x no-wrap">
          <div class="pl-2"></div>
          <div
            @click.stop="select(index,'serverID')"
            v-for="(server, index) in schedule.employees"
            :key="index"
            class="item mr-2 mt-1 isButton2"
          >
            <img
              :class="server.serverID == selected.serverID ? 'border-select primary' : 'border-no-select no-select'"
              class="avatar-70 border-line-2"
              :src="server.serverPhoto"
              alt
            />
          </div>
          <div class="pl-1"></div>
        </div>

        <div class="pl-2 pr-2">
          <div class="row mb-1 mt-3">
            <div
              class="normal capital medium text-no-wrap"
            >{{schedule.listDays[selected.day].month}}</div>
            <div class="spacer"></div>
            <div
              class="normal capital medium text-no-wrap"
            >{{schedule.listDays[selected.day].dayWeekString}}</div>
          </div>
        </div>

        <!-- FECHA -->
        <div class="scroll-x">
          <div class="pl-2"></div>
          <div
            class="col isButton2"
            @click.stop="select(index,'day')"
            v-for="(day, index) in schedule.listDays"
            :key="index"
          >
            <div
              v-if="index >= $store.getters.app.schedule.pastAdmin || $store.getters.profile.adminLevel > 1 "
              :class="index < $store.getters.app.schedule.pastAdmin ? 'grey' : index == selected.day ? 'primary': 'border-no-select no-select'"
              class="col round-50 pa-1 mr-2"
            >
              <div class="avatar-30 subtitle medium capital">
                <div
                  class="col center-items theme"
                  v-if="day.dayWeekString != 'miércoles'"
                >{{day.dayWeekString.charAt(0)}}</div>
                <div class="col center-items theme" v-else>X</div>
              </div>
              <div
                :class="index < selected.day ? 'border-line-1' : index == selected.day ? 'primary border-line-2': 'border-line-1'"
                class="avatar-30 medium subtitle mt-1 theme"
              >
                <div class="col center-items">{{day.dayMonth}}</div>
              </div>
            </div>
          </div>
          <div class="pr-1"></div>
        </div>

        <!-- SERVICIO -->
        <div class="pl-2 pr-2">
          <div class="row mb-1 mt-3">
            <div class="normal capital medium">Servicios</div>
            <div class="spacer"></div>
            <div
              class="normal capital medium"
            >{{schedule.employees[selected.serverID].servicesList[selected.service].service}}</div>
          </div>
        </div>
        <div class="scroll-x pb-1">
          <div class="pl-2"></div>
          <div
            @click.stop="select(index,'service')"
            v-for="(item, index) in  schedule.employees[selected.serverID].servicesList"
            :key="index"
            :class="index ==  selected.service ? 'primary' : 'secondary'"
            class="bizel item pt- pb-1 pr-2 pl-2 mr-2 mt-1 isButton2"
          >
            <div class="medium normal pt-1">{{item.service}}</div>
            <div
              class="text"
            >$ {{item.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}} {{$store.getters.app.country.currency}}</div>
          </div>
          <div class="pl-1"></div>
        </div>

        <!-- TIKETS-->
        <div class="mt-1">
          <div
            v-if="isEmpty && $store.getters.profile.adminLevel < 1"
            class="col center-items mt-2 ml-3 mr-3"
          >
            <div class="mdi subtitle mdi-alert-circle-outline mb-1"></div>
            <div
              class="text center-text ml-3 mr-3 mb-3 pb-3 pl-2 pr-2"
            >Lo sentimos, no tenemos más tiquetes disponibles, intenta buscar otro día</div>
          </div>
          <div v-else class="pl-1 scroll-y tickets col theme">
            <div
              v-for="(ticket, index) in Object.values(schedule.employees[selected.serverID].schedule)[selected.day]"
              :key="index"
              class="item"
            >
              <!-- NIVEL DE TICKET DISPONIBLE -->
              <div
                @click.stop="select({ticket, index},'ticket-free')"
                v-if="ticket.state == 'disponible' || ticket.state == 'cancelado'"
                class="row mb-1 mt-1 item isButton2"
              >
                <div class="spacer"></div>
                <div class="ticket-card mr-2 bizel center-items-y row pa-1 primary">
                  <div class="avatar-30 medium mr-1 ml-1 mt-1 mb-1 opacity-30 subtitle theme">
                    <div class="col title center-items">
                      <span
                        :class="ticket.moment == 'morning' ? 'mdi-weather-sunset' : ticket.moment == 'afternoon' ? 'mdi-weather-sunny' : 'mdi-weather-night'"
                        class="mdi"
                      ></span>
                    </div>
                  </div>
                  <div class="ml-1 spacer">
                    <div class="row">
                      <div class="medium text capital">{{ticket.time}}</div>
                      <div class="spacer"></div>
                      <div
                        class="body mr-1"
                      >{{schedule.employees[selected.serverID].serverTimer}} min</div>
                    </div>
                    <div class="text capital">Disponible</div>
                  </div>
                </div>
              </div>

              <!-- NIVEL DE TICKET DISPONIBLE -->
              <div
                @click.stop="select(ticket,'ticket-view')"
                v-else-if="ticket.state !== 'break' && ticket.state !== 'caducado' && $store.getters.profile.adminLevel > 1 "
                class="row mb-1 mt-1 item isButton2"
              >
                <div class="spacer"></div>
                <div
                  :class="ticket.state == 'confirmado' ? 'green ': 'grey'"
                  class="ticket-card mr-2 bizel center-items-y row pa-1"
                >
                  <div class="avatar-30 mr-1 ml-1 mt-1 mb-1 medium subtitle theme">
                    <img class="avatar-30" :src="ticket.clientPhoto" />
                  </div>
                  <div class="ml-1 spacer">
                    <div class="row">
                      <div class="medium text capital">{{ticket.time}}</div>
                      <div class="spacer"></div>
                      <div class="body capital mr-1">{{ticket.state}}</div>
                    </div>
                    <div class="text capital text-no-wrap">{{ticket.clientNames}}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="item pt-1"></div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import loadVirtual from "./LoadVirtual";
export default {
  components: {
    loadVirtual
  },
  created() {
    this.$store.dispatch("schedule");
    this.selected.day = this.$store.getters.app.schedule.pastAdmin;
  },
  computed: {
    schedule() {
      return this.$store.getters.schedule;
    },
    isEmpty() {
      const value = Object.values(
        Object.values(this.schedule.employees[this.selected.serverID].schedule)[
          this.selected.day
        ]
      ).findIndex(i => i.state === "disponible");
      return value == -1 ? true : false;
    }
  },
  data: () => ({
    selected: {
      serverID: 0,
      day: 0,
      service: 0
    }
  }),
  methods: {
    select(index, param) {
      switch (param) {
        case "day":
          this.selected.day = index;
          break;
        case "serverID":
          this.selected.serverID = index;
          break;
        case "service":
          this.selected.service = index;
          break;
        case "ticket-free":
          const payload = {};
          // client
          payload.clientID = this.$store.getters.profile.clientID;
          payload.clientNames = this.$store.getters.profile.clientNames;
          payload.clientPhoto = this.$store.getters.profile.clientPhoto;
          payload.clientEmail = this.$store.getters.profile.clientEmail;
          payload.clientPhone = this.$store.getters.profile.clientPhone;
          // server
          payload.serverID = this.schedule.employees[
            this.selected.serverID
          ].serverID;
          payload.serverName = this.schedule.employees[
            this.selected.serverID
          ].serverName;
          payload.serverPhoto = this.schedule.employees[
            this.selected.serverID
          ].serverPhoto;
          payload.serverCampus = this.schedule.employees[
            this.selected.serverID
          ].serverCampus;
          // ticket
          payload.state = "disponible";
          payload.moment = index.ticket.moment;
          payload.time = index.ticket.time;
          payload.hour = index.index;
          payload.date = this.schedule.listDays[this.selected.day].date;
          // information
          payload.month = this.schedule.listDays[this.selected.day].month;
          payload.dayMonth = this.schedule.listDays[this.selected.day].dayMonth;
          payload.dayWeekString = this.schedule.listDays[
            this.selected.day
          ].dayWeekString;
          payload.serviceName = this.schedule.employees[
            this.selected.serverID
          ].servicesList[this.selected.service].service;
          payload.servicePrice = this.schedule.employees[
            this.selected.serverID
          ].servicesList[this.selected.service].price;
          this.$store.commit("dataTicket", payload);
          break;
        case "ticket-view":
          this.$store.commit("dataTicket", index);
          break;
      }
    }
  }
};
</script>
<style  scoped>
.box {
  height: 60px;
  width: 60px;
}
.virtual {
  width: 340px;
  height: calc(100vh);
  box-sizing: border-box;
}
.tickets {
  height: calc(100vh - 400px);
}

.ticket-card {
  width: 210px;
}
@media only screen and (max-width: 768px) {
  .virtual {
    width: 100vw;
  }
}
</style>